/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_Data_As_OfInputs */

const cs_property_registry_data_as_of = /** @type {(inputs: Property_Registry_Data_As_OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data ke dni`)
};

const en_property_registry_data_as_of = /** @type {(inputs: Property_Registry_Data_As_OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data as of`)
};

/**
* | output |
* | --- |
* | "Data as of" |
*
* @param {Property_Registry_Data_As_OfInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_data_as_of = /** @type {((inputs?: Property_Registry_Data_As_OfInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_Data_As_OfInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_data_as_of(inputs)
	return cs_property_registry_data_as_of(inputs)
});